import React, { useRef, useState } from 'react'
import { getMessage } from 'lib/translator'
import uploadIcon from '../BulkUploadSKUMeta/upload-products.svg'

function SkuMediaDropzone({
  accept,
  browseKey,
  disabled,
  dropzoneTestId,
  filterFiles,
  hintKey,
  inputTestId,
  multiple = false,
  onFilesSelected,
  titleKey,
}) {
  const inputRef = useRef(null)
  const [dragActive, setDragActive] = useState(false)

  const emitFiles = (rawFiles, fromDrop = false) => {
    if (disabled) {
      return
    }

    const fileList = Array.from(rawFiles || [])
    if (!fileList.length) {
      return
    }

    const files = fromDrop && filterFiles ? filterFiles(fileList) : fileList
    if (!files.length) {
      return
    }

    onFilesSelected(files)
  }

  const handleInputChange = (event) => {
    emitFiles(event.target.files, false)
    event.target.value = ''
  }

  const handleDrag = (event) => {
    event.preventDefault()
    event.stopPropagation()
    if (disabled) {
      return
    }
    setDragActive(event.type === 'dragenter' || event.type === 'dragover')
  }

  const handleDrop = (event) => {
    event.preventDefault()
    event.stopPropagation()
    setDragActive(false)
    if (disabled) {
      return
    }
    emitFiles(event.dataTransfer.files, true)
  }

  return (
    <div
      className={`sku-media-dropzone bordered-box${dragActive ? ' drag-active' : ''}${
        disabled ? ' disabled' : ''
      }`}
      onDragEnter={handleDrag}
      onDragOver={handleDrag}
      onDragLeave={handleDrag}
      onDrop={handleDrop}
      data-testid={dropzoneTestId}
    >
      <div className="text-center">
        <img src={uploadIcon} width="140" alt="" />
      </div>
      <p className="sku-media-dropzone-title">{getMessage(titleKey)}</p>
      <p className="sku-media-dropzone-hint">{getMessage(hintKey)}</p>
      <button
        type="button"
        className="button primary"
        disabled={disabled}
        onClick={() => inputRef.current?.click()}
      >
        {getMessage(browseKey)}
      </button>
      <input
        ref={inputRef}
        type="file"
        multiple={multiple}
        accept={accept}
        className="sku-media-file-input"
        data-testid={inputTestId}
        disabled={disabled}
        onChange={handleInputChange}
      />
    </div>
  )
}

export default SkuMediaDropzone
